import { GraduationCap, HardHat, Cog, ArrowRight } from "lucide-react";
import { SectionHeader } from "./Section";
import training from "@/assets/training.jpg";

const PROGRAMS = [
  {
    icon: HardHat,
    tag: "QHSE",
    title: "QHSE Courses",
    desc: "Quality, Health, Safety and Environmental training aligned with international best practice.",
    items: [
      "H2S Awareness",
      "Working at Heights",
      "Permit to Work",
      "Risk Assessment",
      "Incident Investigation",
    ],
  },
  {
    icon: Cog,
    tag: "Technical",
    title: "Technical Training",
    desc: "Discipline-specific technical training for inspectors, riggers and maintenance crews.",
    items: [
      "Rigger Level I, II, III",
      "Banksman / Slinger",
      "NDT Awareness",
      "API Crane Inspector Prep",
      "LEEA Modules",
    ],
  },
  {
    icon: GraduationCap,
    tag: "Industrial",
    title: "Industrial Training Programs",
    desc: "Tailored on-site programs for operators across energy, marine and heavy industry.",
    items: [
      "Customised Site Training",
      "Competency Assessment",
      "Train-the-Trainer",
      "Certification Pathways",
    ],
  },
];

export function Training() {
  return (
    <section id="training" className="section-y bg-light-gray">
      <div className="container-x">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <SectionHeader
              eyebrow="Training & Competency"
              title="Industry-grade training that builds safer, sharper teams."
              intro="Our accredited training programs prepare technicians, inspectors and operators to perform safely, competently and in full compliance with international standards."
            />
          </div>
          <div className="lg:col-span-5">
            <img
              src={training}
              alt="Industrial training classroom with engineers"
              width={1280}
              height={800}
              loading="lazy"
              className="aspect-[16/10] w-full rounded-xl object-cover shadow-xl"
            />
          </div>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {PROGRAMS.map((p) => (
            <div
              key={p.title}
              className="group flex flex-col rounded-2xl border border-border bg-card p-7 transition-all hover:-translate-y-1 hover:border-orange hover:shadow-xl"
            >
              <div className="flex items-center gap-3">
                <span className="grid h-12 w-12 place-items-center rounded-md bg-navy-deep text-orange transition-colors group-hover:bg-orange group-hover:text-white">
                  <p.icon className="h-6 w-6" />
                </span>
                <span className="rounded-full bg-orange/10 px-3 py-1 text-xs font-bold uppercase tracking-widest text-orange">
                  {p.tag}
                </span>
              </div>
              <h3 className="mt-5 text-xl font-bold text-navy-deep">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{p.desc}</p>
              <ul className="mt-5 space-y-2 border-t border-border pt-5">
                {p.items.map((i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-navy-deep">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-orange" />
                    {i}
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-orange hover:underline"
              >
                Request schedule <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
